import { render, staticRenderFns } from "./SenderEmailSettings.vue?vue&type=template&id=c6fe6282&scoped=true"
import script from "./SenderEmailSettings.vue?vue&type=script&lang=js"
export * from "./SenderEmailSettings.vue?vue&type=script&lang=js"
import style0 from "./SenderEmailSettings.vue?vue&type=style&index=0&id=c6fe6282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fe6282",
  null
  
)

export default component.exports